// ProductImageSlider.js

import React, { useState, useEffect } from 'react';
import '../css/ProductImageSlider.css'; // Create a CSS file for styling
import { domain } from './Domain';

const ProductImageSlider = ({ images }) => {
    const safeImages = Array.isArray(images) ? images.filter(Boolean) : [];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        setCurrentImageIndex(0);
    }, [images]);

    const len = safeImages.length;
    const showNav = len > 1;

    const nextImage = () => {
        if (len < 2) return;
        setCurrentImageIndex((i) => (i + 1) % len);
    };

    const prevImage = () => {
        if (len < 2) return;
        setCurrentImageIndex((i) => (i - 1 + len) % len);
    };

    const changeImage = (index) => {
        setCurrentImageIndex(index);
    };

    if (len === 0) {
        return (
            <div className="product-image-slider product-image-slider--empty">
                <div className="main-image-container">
                    <div className="main-image main-image--placeholder" role="img" aria-label="No product image">
                        <span>No image</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="product-image-slider">
            <div className="main-image-container">
                {showNav && (
                    <button type="button" className="prev-button" onClick={prevImage} aria-label="Previous image">
                        &lt;
                    </button>
                )}
                <img
                    src={domain + safeImages[currentImageIndex]}
                    alt="Product"
                    className="main-image"
                />
                {showNav && (
                    <button type="button" className="next-button" onClick={nextImage} aria-label="Next image">
                        &gt;
                    </button>
                )}
            </div>
            {showNav && (
                <div className="thumbnail-images">
                    {safeImages.map((image, index) => (
                        <img
                            key={index}
                            src={domain + image}
                            alt=""
                            className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                            onClick={() => changeImage(index)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductImageSlider;
